import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { CustomValidatorService } from '@klickdata/core/form/src/validators/custom-validator.service';
import { OccasionsDatesData } from '@klickdata/core/resource/src/occasions-dates/occasions-dates.model';

@Component({
    selector: 'app-add-occasio-on-the-fly',
    templateUrl: './add-occasio-on-the-fly.component.html',
    styleUrls: ['./add-occasio-on-the-fly.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddOccasioOnTheFlyComponent implements OnInit {
    resourceOccasionsMetadataForm: FormGroup;
    resourceOccasionsFormArray: FormArray;
    @Output() occasionChange = new EventEmitter<{ valid: boolean; value?: OccasionsDatesData }>();

    constructor(private fb: FormBuilder, protected validatorService: CustomValidatorService) {
        this.resourceOccasionsFormArray = new FormArray([]);
        this.resourceOccasionsMetadataForm = this.fb.group(
            {
                occasion_dates: this.resourceOccasionsFormArray,
                occasion_always_open: [false],
            },
            { validators: [this.validatorService.occasionDatesValidator] }
        );
        this.resourceOccasionsFormArray.push(this.createNewOccasionFormGroup());
    }

    ngOnInit(): void {
        this.emitOccasionChange();
        this.resourceOccasionsMetadataForm.valueChanges.subscribe(() => {
            this.emitOccasionChange();
        });
    }
    get occasionDatesErrors(): { [key: string]: string[] } | null {
        const errors = this.resourceOccasionsMetadataForm?.errors?.['occasionDates'];
        return (errors ?? null) as { [key: string]: string[] } | null;
    }
    private emitOccasionChange(): void {
        if (!this.resourceOccasionsMetadataForm.valid) {
            this.occasionChange.emit({ valid: false });
            return;
        }

        this.occasionChange.emit({
            valid: true,
            value: this.resourceOccasionsMetadataForm.get('occasion_dates').value[0],
        });
    }
    private resetOccasionForms(): void {
        this.resourceOccasionsFormArray.clear();
        this.resourceOccasionsFormArray.push(this.createNewOccasionFormGroup());
        this.resourceOccasionsMetadataForm.reset(
            {
                occasion_dates: this.resourceOccasionsFormArray.value,
                occasion_always_open: false,
            },
            { emitEvent: false }
        );
        this.resourceOccasionsMetadataForm.markAsPristine();
        this.resourceOccasionsMetadataForm.markAsUntouched();
    }
    private createNewOccasionFormGroup(): FormGroup {
        return this.fb.group({
            id: [null],
            start_date: [''],
            end_date: [''],
            application_start_date: [''],
            application_end_date: [''],
            total_seats: [0],
            unlimited_seats: [true],
            location: [''],
            grib: [''],
            activity: [''],
            other: [''],
            target_group: [''],
            expanded: [false],
        });
    }
}
